/**
 * Mock appointment data generation functions for testing and development
 */

/**
 * Generate mock appointments based on customers, practitioners, treatments, and venues
 * @param {Array} customers
 * @param {Array} practitioners
 * @param {Array} treatments
 * @param {Array} venues
 * @returns {Array} Array of mock appointment objects
 */
import { v4 as uuidv4 } from 'uuid';
import { mockCustomers } from './mockCustomers';
import { mockPractitioners } from './mockPractitioners';
import { mockTreatments } from './mockTreatments';
import { mockVenues } from './mockVenues';

export const mockAppointments = [];
export default mockAppointments; 